var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('sub-title',{attrs:{"title":"参编书籍"}}),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"block",style:({backgroundImage:'url('+item.img+')'})})])}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }